var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finish"},[_c('div',{staticClass:"words"},[_c('p',{staticClass:"title"},[_vm._v("恭喜您完成全部测评")]),_c('el-button',{staticClass:"exit",attrs:{"type":"primary"},on:{"click":_vm.toExit}},[_vm._v("退出")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }